import React, { Component } from 'react';
import { connect } from 'react-redux';
import GDocsCustomerGuide from '../../../assets/images/GDocsCustomerGuide.pdf';

// css files
import './OtherSection.css';

class OtherSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    }
  }

  collapse = () => {
    if (this.state.isOpen === false) {
      this.setState({
        isOpen: true
      })
    } else {
      this.setState({
        isOpen: false
      })
    }
  }

  handleClick = (Urn) => {
    try {
      if (this.props.history.location.state.Urn) {
        this.props.history.push({
          pathname: `/case-body/supporting-doc/${this.props.history.location.state.Urn}`,
          state: { Urn: this.props.history.location.state.Urn }
        });
      }
    }
    catch (e) {
      if (Urn !== undefined) {
        this.props.history.push({
          pathname: `/case-body/supporting-doc/${Urn}`,
          state: { Urn: Urn }
        });
      } else {
        alert("Wrong Case Id");
      }
    }
  }
  handleClickSowHistory = () => {
    try {
      let agentDetail = this.props.sowEntities.filter(entity => {
        return entity.agent
      })
      let sowId = agentDetail[0].groupId
      this.props.history.push({
        pathname: `/sow-body/sow-history/${sowId}`,
        state: { Urn: sowId }
      });

    }
    catch (e) {
      // if (Urn !== undefined) {
      //   this.props.history.push({
      //     pathname: `/case-body/case-history/${Urn}`,
      //     state: { Urn: Urn }
      //   });
      // } else {
      //   alert("Wrong Case Id");
      // }
    }
  }
  cashConGuideButtonPressed = () => {

  }
  npGuideButtonPressed = () => {

  }
  IEGuideButtonPressed = () => {

  }

  handleClickHistory = (Urn) => {
    try {
      if (this.props.history.location.state.Urn) {
        this.props.history.push({
          pathname: `/case-body/case-history/${this.props.history.location.state.Urn}`,
          state: { Urn: this.props.history.location.state.Urn }
        });
      }
    }
    catch (e) {
      if (Urn !== undefined) {
        this.props.history.push({
          pathname: `/case-body/case-history/${Urn}`,
          state: { Urn: Urn }
        });
      } else {
        alert("Wrong Case Id");
      }
    }
  }

  render() {
    const { headerTitle, sowHeaderTitle } = this.props
    return (
      <div className="case-menu__section">
        <h2 className="case-menu__section__header gdocs-responsive-text">{this.props.sow ? sowHeaderTitle : headerTitle}</h2>
        <span className="case-menu__section__bar"></span>
        <ul className={this.state.isOpen === true ? `case-menu__list gdocs-responsive-text` : 'case-menu__list gdocs-responsive-text hide'}>
          {this.props.sow ? null : <li className="horizontal-rules">
            <div style={{ paddingTop: "10px" }}></div>
            <button className="case-menu__list__item other-options-font" onClick={() => this.handleClick(this.props.Urn)} >
              {this.props.supportingDocs}
            </button>
          </li>}
          {
            <li>
              <div style={{ paddingTop: "10px" }}></div>
              <a
                className="case-menu-guide__list__item gdocs-responsive-text other-options-font"
                href="https://www.gbm.hsbc.com/-/media/media/gbm-global/pdf/products/product-guide-gls-cash-concentration"
                rel="noopener noreferrer"
                tabIndex="0"
                target="_blank"
                title={this.props.Cashcon_Guide}
              >
                <i class="icon icon-new-window icon-pad" aria-label='Opens in new window'></i>
                {this.props.Cashcon_Guide}
              </a>
            </li>
          }
          {
            <li>
              <div style={{ paddingTop: "10px" }}></div>
              <a
                className="case-menu-guide__list__item gdocs-responsive-text other-options-font"
                href="https://www.gbm.hsbc.com/-/media/media/gbm-global/pdf/products/product-guide-gls-notional-pooling"
                rel="noopener noreferrer"
                tabIndex="0"
                target="_blank"
                title={this.props.NP_Guide}
              >
                <i class="icon icon-new-window icon-pad" aria-label='Opens in new window'></i>
                {this.props.NP_Guide}
              </a>
            </li>
          }
          {
            <li>
              <div style={{ paddingTop: "10px" }}></div>
              <a
                className="case-menu-guide__list__item gdocs-responsive-text other-options-font"
                href="https://www.gbm.hsbc.com/-/media/media/gbm-global/pdf/products/product-guide-gls-interest-enhancement"
                rel="noopener noreferrer"
                tabIndex="0"
                target="_blank"
                title={this.props.IE_Guide}
              >
                <i class="icon icon-new-window icon-pad" aria-label='Opens in new window'></i>
                {this.props.IE_Guide}
              </a>
            </li>
          }
          <div className='case-menu__list__item-action'>
            {!this.props.customer && !this.props.sow &&
              <li>
                <div style={{ paddingTop: "10px" }}></div>
                <button className="case-menu__list__item other-options-font " onClick={() => this.handleClickHistory(this.props.Urn)}>
                  {this.props.caseHistory}
                </button>
              </li>
            }
            {!this.props.customer && this.props.sow &&
              <li>
                <div style={{ paddingTop: "10px" }}></div>
                <button className="case-menu__list__item other-options-font " onClick={this.handleClickSowHistory}>
                  {this.props.sowHistory}
                </button>
              </li>
            }
            {this.props.customer && <li className="case-menu__list__item other-options-font gdocsCustomerGuide">
              <div style={{ paddingTop: "10px" }}></div>
              <a
                className="case-menu__list__item other-options-font"
                href={GDocsCustomerGuide}
                rel="noopener noreferrer"
                tabIndex="0"
                target="_blank"
                title={this.props.customerGuide}
              >
                <i class="icon icon-new-window icon-pad"></i>
                {this.props.customerGuide}
                <span className="visuallyhidden">{this.props.label}</span>
              </a>
            </li>
            }
          </div>
        </ul>
      </div>
    )
  }
}

OtherSection.defaultProps = {
  caseHistory: 'Case History',
  supportingDocs: 'Supporting Documents'
}

const mapStateToProps = state => {
  return {
    customer: state.auth.userDetails.roleDetails.customer
  }
}
export default connect(mapStateToProps, null)(OtherSection);



// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/OtherSection.js